import type { IdScanningFaceBox } from 'garaje/models/screener-result';

const CROP_PADDING = 1.4;

/**
 * Square crop window around a face box, in image pixels. The box is
 * Rekognition-style relative ratios (0-1 of image dimensions); the window is
 * padded, centered on the face, and clamped to the image bounds.
 */
export function squareCrop(
  box: IdScanningFaceBox,
  imageWidth: number,
  imageHeight: number,
): { x: number; y: number; side: number } {
  const side = Math.min(
    Math.max(box.width * imageWidth, box.height * imageHeight) * CROP_PADDING,
    Math.min(imageWidth, imageHeight),
  );
  const centerX = (box.left + box.width / 2) * imageWidth;
  const centerY = (box.top + box.height / 2) * imageHeight;
  const x = Math.min(Math.max(centerX - side / 2, 0), imageWidth - side);
  const y = Math.min(Math.max(centerY - side / 2, 0), imageHeight - side);
  return { x, y, side };
}
